










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import TimelineContent from '@/components/action_report/TimelineContent.vue';

@Component({
  components: {
    Header,
    TimelineContent,
    Footer,
  },
})
export default class ActionTimeline extends Vue {}
